import { common } from '@src/api/actions';
import { getSafe } from '@src/tools/util';
export const getAllUsers = (range) => common.getAllUsers({
    range,
}).then((res) => getSafe(res, 'data', []));
